export const colors = ["primary", "secondary", "default", "success", "danger"];
export const sizes = ["sm", "md", "lg"];
export const prefix = "mm";
